import { LiveStreamAnalytics } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/metadata/live-stream-analytics';
import { LiveStreamListRequest } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/requests/live-stream-list-request';
import { LiveStreamListResponse } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/responses/live-stream-list-response';
import {
  LiveStreamState,
  OrderDirection,
} from '@wix/media-platform-js-client/dist/mjs/src/types/media-platform/media-platform';
import { ProjectInOrganizationId } from '../../types/entities';
import { mediaPlatformProvider } from '../media-platform-provider';
import { LiveStreamListFilter } from '../../redux/reducers/live-streams/live-streams.reducer';

const LiveStreamStatesAll = [
  LiveStreamState.CLOSED,
  LiveStreamState.DVR_PROCESSING,
  LiveStreamState.PENDING_RECONNECT,
  LiveStreamState.CREATED,
  LiveStreamState.STREAMING,
];

const LiveStreamStatesActive = [
  LiveStreamState.PENDING_RECONNECT,
  LiveStreamState.STREAMING,
];

const LiveStreamStatesInactive = [
  LiveStreamState.CLOSED,
  LiveStreamState.CREATED,
  LiveStreamState.DVR_PROCESSING,
];

const getLiveStreams = (
  { organizationId, project }: ProjectInOrganizationId,
  filter: LiveStreamListFilter,
): Promise<LiveStreamListResponse> => {
  return getAllLiveStreams({ organizationId, project }, filter);
};

function statesForFilter(filter: LiveStreamListFilter): LiveStreamState[] {
  if (filter === LiveStreamListFilter.Active) {
    return LiveStreamStatesActive;
  }
  if (filter === LiveStreamListFilter.Inactive) {
    return LiveStreamStatesInactive;
  }

  return LiveStreamStatesAll;
}

const getAllLiveStreams = async (
  { organizationId, project }: ProjectInOrganizationId,
  filter: LiveStreamListFilter,
  nextPageToken?: string,
  pageSize?: number,
): Promise<LiveStreamListResponse> => {
  const liveManager = mediaPlatformProvider.getSDKInstance(
    organizationId,
    project,
  ).liveManager;
  const liveStreamListRequest = new LiveStreamListRequest({
    state: statesForFilter(filter),
    nextPageToken,
    pageSize,
    orderBy: 'dateCreated',
    orderDirection: OrderDirection.DES,
  });

  const streams = await liveManager.listStreams(liveStreamListRequest);
  return streams;
};

const getLiveStreamAnalytics = (
  { organizationId, project }: ProjectInOrganizationId,
  liveStreamId: string,
): Promise<LiveStreamAnalytics> => {
  const liveManager = mediaPlatformProvider.getSDKInstance(
    organizationId,
    project,
  ).liveManager;

  return liveManager.getStreamAnalytics(liveStreamId);
};

const getStreamFrameUrl = async (
  { organizationId, project }: ProjectInOrganizationId,
  streamId: string | null,
): Promise<string> => {
  if (!streamId) {
    throw Error('No Stream Id');
  }

  const liveManager = mediaPlatformProvider.getSDKInstance(
    organizationId,
    project,
  ).liveManager;
  return liveManager.getStreamCoverUrl(streamId as string);
};

export const liveStreamsService = {
  getLiveStreams,
  getAllLiveStreams,
  getLiveStreamAnalytics,
  getStreamFrameUrl,
};
